import ThreeARPipeline from "scripts/pipeline/ThreeARPipeline";
import ThreejsPipeline from "scripts/pipeline/ThreejsPipeline";
import { customizeUI, customizePreview } from "scripts/util/8thwall";
import * as THREE from "three";

window.THREE = THREE;

export default new (class {
  load = () => {
    this.worldFacing = true;

    return new Promise((resolve) => {
      Promise.all([
        new Promise((resolve) => {
          const interval = setInterval(() => {
            if (window.XR8 && window.XRExtras) {
              clearInterval(interval);
              resolve();
            }
          }, 50);
        }),
      ]).then(() => {
        window.XRExtras.Loading.showLoading();
        customizeUI();
        this.initPipeline().then(resolve);
      });
    });
  };

  initPipeline = () =>
    new Promise((resolve) => {
      window.XR8.XrController.configure({
        disableWorldTracking: this.worldFacing === false,
        enableLighting: false,
      });

      window.XRExtras.MediaRecorder.configure({
        fileNamePrefix: `kia-dogmented-`,
      });

      window.XRExtras.MediaRecorder.setCaptureMode("photo"); // Photo capture Only
      window.XRExtras.MediaRecorder.initRecordButton(); // Adds record button
      window.XRExtras.MediaRecorder.initMediaPreview(); // Adds media preview and share
      customizePreview();

      window.XR8.addCameraPipelineModules([
        window.XR8.GlTextureRenderer.pipelineModule(), // Draws the camera feed.
        // window.XR8.Threejs.pipelineModule(),
        ThreejsPipeline, // Creates a ThreeJS AR Scene.
        window.XR8.XrController.pipelineModule(), // Enables SLAM tracking.
        window.XRExtras.AlmostThere.pipelineModule(), // Detects unsupported browsers and gives hints.
        window.XRExtras.FullWindowCanvas.pipelineModule(), // Modifies the canvas to fill the window.
        window.XRExtras.Loading.pipelineModule(), // Manages the loading screen on startup.
        window.XRExtras.RuntimeError.pipelineModule(), // Shows an error image on runtime error.
        window.XR8.CanvasScreenshot.pipelineModule(), // Enables screencapture of feed
        ThreeARPipeline,
      ]);

      window.XR8.addCameraPipelineModule({
        name: "camerastartupmodule",
        onCameraStatusChange: ({ status }) => {
          // alert(status)
          if (status === "failed") {
            window.open("/error", "_self", "");
          }
        },
      });

      window.XR8.run({
        canvas: document.getElementById("ar-canvas"),
        cameraConfig: {
          direction: this.worldFacing
            ? window.XR8.XrConfig.camera().BACK
            : window.XR8.XrConfig.camera().FRONT,
        },
      });

      const check = setInterval(() => {
        if (window.XRStarted) {
          this.running = true;
          clearInterval(check);
          resolve();
        }
      }, 50);
    });

  flipCamera = () => {
    this.worldFacing = !this.worldFacing;

    window.XR8.stop();

    // window.XR8.removeCameraPipelineModules([
    //   window.XR8.GlTextureRenderer.pipelineModule(), // Draws the camera feed.
    //   // window.XR8.Threejs.pipelineModule(),
    //   ThreejsPipeline, // Creates a ThreeJS AR Scene.
    //   window.XR8.XrController.pipelineModule(), // Enables SLAM tracking.
    //   window.XRExtras.AlmostThere.pipelineModule(), // Detects unsupported browsers and gives hints.
    //   window.XRExtras.FullWindowCanvas.pipelineModule(), // Modifies the canvas to fill the window.
    //   window.XRExtras.Loading.pipelineModule(), // Manages the loading screen on startup.
    //   window.XRExtras.RuntimeError.pipelineModule(), // Shows an error image on runtime error.
    //   window.XR8.CanvasScreenshot.pipelineModule(), // Enables screencapture of feed
    //   ThreeARPipeline,
    //   "camerastartupmodule",
    // ]);

    window.XR8.XrController.configure({
      disableWorldTracking: this.worldFacing === false,
      mirroredDisplay: this.worldFacing === false,
      // enableLighting: false,
    });

    // window.XR8.addCameraPipelineModules([
    //   window.XR8.GlTextureRenderer.pipelineModule(), // Draws the camera feed.
    //   // window.XR8.Threejs.pipelineModule(),
    //   ThreejsPipeline, // Creates a ThreeJS AR Scene.
    //   window.XR8.XrController.pipelineModule(), // Enables SLAM tracking.
    //   window.XRExtras.AlmostThere.pipelineModule(), // Detects unsupported browsers and gives hints.
    //   window.XRExtras.FullWindowCanvas.pipelineModule(), // Modifies the canvas to fill the window.
    //   window.XRExtras.Loading.pipelineModule(), // Manages the loading screen on startup.
    //   window.XRExtras.RuntimeError.pipelineModule(), // Shows an error image on runtime error.
    //   window.XR8.CanvasScreenshot.pipelineModule(), // Enables screencapture of feed
    //   ThreeARPipeline,
    // ]);

    // window.XR8.addCameraPipelineModule({
    //   name: "camerastartupmodule",
    //   onCameraStatusChange: ({ status }) => {
    //     if (status === "failed") {
    //       // window.open("/error", "_self", "");
    //     }
    //   },
    // });
    const interval = setInterval(() => {
      const permissions = document.querySelector(
        "#requestingCameraPermissions"
      );
      const image = document.querySelector(
        "#loadImageContainer .foreground-image"
      );
      if (permissions && image) {
        permissions.style.display = "none";
        image.style.display = "none";
        clearInterval(interval);
      }
    }, 1);
    setTimeout(() => {
      if (interval) clearInterval(interval);
    }, 2000);

    window.XR8.run({
      canvas: document.getElementById("ar-canvas"),
      cameraConfig: {
        direction: this.worldFacing
          ? window.XR8.XrConfig.camera().BACK
          : window.XR8.XrConfig.camera().FRONT,
      },
    });
  };
})();
